import { forwardRef, useRef } from 'react'
import InputMask from 'react-input-mask'

import * as S from './styles'

const Input = forwardRef((props, ref) => {
  const inputRef = useRef(null)

  let invalidText = ' (Obrigatório)'
  if (props.invalidText) {
    invalidText = ` (${props.invalidText})`
  }

  const handleIconClick = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  return (
    <S.FormInput
      id={props.id}
      className={props.required ? 'formInput' : ''}
      invalid={props.invalid}
    >
      <S.Label htmlFor={props.id}>
        {props.label}
        {props.required && <strong>*</strong>}
      </S.Label>

      <S.InputWrapper
        className='input-wrapper'
        disabled={props.disabled}
        onClick={handleIconClick}
      >
        {props.leftIcon &&
          <div className='icon'>{props.leftIcon}</div>
        }

        {props.children ? props.children : props.mask ? (
          <InputMask
            maskPlaceholder={props.maskPlaceholder}
            mask={props.mask}
            defaultValue={props.defaultValue}
            value={props.value}
            onChange={props.onChange}
            disabled={props.disabled}
            onBlur={props.onBlur}
            onFocus={props.onFocus}
          >
            <S.Input
              placeholder={props.placeholder}
              type={props.type}
              id={props.id}
              name={props.name}
              onChange={props.onChange}
              onInput={props.onInput}
              onWheel={props.onWheel}
              maxLength={props.maxLength}
              ref={ref || inputRef}
            />
          </InputMask>
        ) : (
          <S.Input
            placeholder={props.placeholder}
            type={props.type}
            id={props.id}
            name={props.name}
            value={props.value}
            onChange={props.onChange}
            defaultValue={props.defaultValue}
            onBlur={props.onBlur}
            onFocus={props.onFocus}
            disabled={props.disabled}
            onInput={props.onInput}
            onWheel={props.onWheel}
            maxLength={props.maxLength}
            ref={ref || inputRef}
          />
        )}

        {props.rightIcon &&
          <div className='icon'>{props.rightIcon}</div>
        }
      </S.InputWrapper>

      <S.Span>{props.invalid && invalidText}</S.Span>
    </S.FormInput >
  )
})

export default Input
